/*
 * Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
 * #  This file forms part of the Trade-DSM application frontend.
 * #  https://github.com/Tooblippe/trade-dsm-frontend
 */

import Vue from 'vue';
import VueRouter from 'vue-router';
import {toCanonicalReloadUrl} from '@/components/application-level/js_functions/referrer-utils';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () =>
      import('@/components/application-level/login-dialog-loader.vue'),
  },
  {
    path: '/login_aexi',
    name: 'login_aexi',
    redirect: () => ({path: '/login', query: {referrer: 'aexi'}}),
  },
  {
    path: '/login_aexi_1',
    name: 'login_aexi_1',
    redirect: () => ({path: '/login', query: {referrer: 'aexi-1'}}),
  },
  {
    path: '/login_aexi_2',
    name: 'login_aexi_2',
    redirect: () => ({path: '/login', query: {referrer: 'aexi-2'}}),
  },
  // {
  //   path: '/application-selection',
  //   name: 'application-selection',
  //   component: () => import('@/components/application-level/application-selector-page'),
  // },
  {
    path: '/trade-dsm',
    name: 'trade-dsm',
    component: () => import('@/components/trade-dsm-application/trade-dsm-application'),
  },
  {
    path: '/trade-sars-national',
    name: 'trade-sars-national',
    component: () => import('@/components/trade-sars-national/trade-sars-national'),
  },
  {
    path: '/trade-crm-app-rfi-process',
    name: 'trade-crm-app-rfi-process',
    component: () =>
      import('@/components/trade-crm-app/rfi_process/trade-crm-app-rfi-process'),
  },
  {
    path: '/trade-data-app',
    name: 'trade-data',
    component: () => import('@/components/trade-data-app/trade-data-app'),
  },
];

const router = new VueRouter({
  routes,
});

// Navigation guard to persist reload_url when navigating to login
router.beforeEach((to, from, next) => {
  // If navigating to the login route and it has a referrer query param
  if (to.path === '/login' && to.query.referrer) {
    // Persist the canonical reload URL
    const canonicalUrl = toCanonicalReloadUrl(to.query.referrer);
    localStorage.setItem('reload_url', canonicalUrl);
  }
  next();
});

export default router;
